import { Component } from '@angular/core'

@Component({
  selector: 'se-po-add-child-profile-docs',
  templateUrl: './add-child-profile-docs.component.html',
  styleUrls: ['./add-child-profile-docs.component.scss'],
  standalone: false,
})
export class AddChildProfileDocsComponent {
  public headers: string[] = [
    'Property',
    'Type',
    'Description',
  ]
  public addChildContactInfoComponent: any = [
    {
      Property: '@Input() persona',
      Type: 'Persona',
      Description: 'Child persona to add contact info to',
    }
  ]
}
